// Minimal, safe Markdown renderer for product descriptions (no HTML injection).
// Supports: # / ## / ### headings, - bullets, | tables |, **bold**, paragraphs.

function inline(text, keyBase) {
  const parts = String(text).split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**") ? (
      <strong key={`${keyBase}-${i}`} className="font-semibold text-neutral-900">{p.slice(2, -2)}</strong>
    ) : (
      <span key={`${keyBase}-${i}`}>{p}</span>
    )
  );
}

const cells = (line) => line.trim().replace(/^\||\|$/g, "").split("|").map((c) => c.trim());

export default function RichText({ text, className = "" }) {
  const lines = String(text || "").replace(/\r/g, "").split("\n");
  const out = [];
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    const t = line.trim();
    if (!t) { i++; continue; }
    if (/^#{1,3}\s/.test(t)) {
      const level = t.match(/^#+/)[0].length;
      const body = t.replace(/^#+\s*/, "");
      const cls = level === 1 ? "text-lg sm:text-xl font-bold mt-2 mb-2" : level === 2 ? "text-base font-bold mt-5 mb-2" : "text-sm font-semibold mt-4 mb-1";
      out.push(<div key={i} className={`font-heading text-neutral-900 ${cls}`}>{inline(body, i)}</div>);
      i++; continue;
    }
    if (/^[-*]\s/.test(t)) {
      const items = [];
      while (i < lines.length && /^[-*]\s/.test(lines[i].trim())) { items.push(lines[i].trim().slice(2)); i++; }
      out.push(<ul key={i} className="list-disc pl-5 space-y-1 my-2">{items.map((it, k) => <li key={k}>{inline(it, `${i}-${k}`)}</li>)}</ul>);
      continue;
    }
    if (t.startsWith("|")) {
      const rows = [];
      while (i < lines.length && lines[i].trim().startsWith("|")) { rows.push(lines[i]); i++; }
      const body = rows.filter((r) => !/^\|?\s*:?-{2,}/.test(r.trim().replace(/^\|/, "")));
      const [head, ...rest] = body.map(cells);
      out.push(
        <div key={i} className="overflow-x-auto my-3">
          <table className="w-full text-sm border border-neutral-200 rounded">
            <thead className="bg-neutral-50"><tr>{(head || []).map((h, k) => <th key={k} className="text-left font-semibold px-3 py-2 border-b border-neutral-200">{inline(h, `h${k}`)}</th>)}</tr></thead>
            <tbody>{rest.map((r, ri) => <tr key={ri} className={ri % 2 ? "bg-neutral-50/50" : ""}>{r.map((c, ci) => <td key={ci} className="px-3 py-2 border-b border-neutral-100">{inline(c, `${ri}-${ci}`)}</td>)}</tr>)}</tbody>
          </table>
        </div>
      );
      continue;
    }
    const para = [];
    while (i < lines.length && lines[i].trim() && !/^(#{1,3}\s|[-*]\s|\|)/.test(lines[i].trim())) { para.push(lines[i].trim()); i++; }
    out.push(<p key={i} className="my-2">{inline(para.join(" "), i)}</p>);
  }
  return <div className={className}>{out}</div>;
}

export function plainText(text) {
  return String(text || "").replace(/[#*|]/g, " ").replace(/-{3,}/g, " ").replace(/\s+/g, " ").trim();
}
